import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { signOutPac } from '../../store/modules/auth/patient/actions';
import { prontuarioReset } from '../../redux/features/prontuario/prontuarioSlice';
import { clearCache } from '../../hooks/clearCache';
import logo from '../../assets/logo.png';
import styles from '../../styles.module.css';
import history from '../../services/history';

export default function NavBar() {
  const { patient } = useSelector(state => state.patient);
  const dispatch = useDispatch();

  function handleSignOut() {
    dispatch(prontuarioReset());
    clearCache();
    dispatch(signOutPac()); // nesse momento que a sessão do paciente é encerrada
  }

  return (
    <Navbar bg="info" expand="lg" className={styles.navbarLink}>
      <Navbar.Brand>
        <img src={logo} alt="logo" width={60} height={60} />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto">
          <Nav.Link onClick={() => history.push('/paciente/inicio')}>
            Início
          </Nav.Link>
          <NavDropdown title="Agendamentos">
            <NavDropdown.Item
              onClick={() =>
                history.push(`/agendamento?cpf=${patient?.cpf || ''}`)
              }
            >
              Novo Agendamento
            </NavDropdown.Item>
            <NavDropdown.Item onClick={() => history.push('/paciente/agendamentos')}>
              Meus Agendamentos
            </NavDropdown.Item>
          </NavDropdown>
          <Nav.Link onClick={() => history.push('/paciente/exames')}>
            Resultado de Exames
          </Nav.Link>
          <Nav.Link onClick={handleSignOut}>Sair</Nav.Link>
        </Nav>
        <Navbar.Text>
          {patient
            ? `${patient.nome
              .toUpperCase()
              .split(' ')
              .slice(0, 2)
              .join(' ')} - ${patient.codPac}`
            : new Date().toDateString()}
        </Navbar.Text>
      </Navbar.Collapse>
    </Navbar>
  );
}
